package modysy.simulation.collision

import modysy.datastructures.Vector2
import modysy.model.Transform

/** Represent a axis-aligned bounding box.
  *
  * @param bottomLeft The point of the bounding box that has minimum x coordinate and maximum y coordinate.
  * @param topRight   The point of the bounding box that has maximum x coordinate and minimum y coordinate.
  */
case class AxisAlignedBoundingBox(
    val bottomLeft: Vector2,
    val topRight: Vector2
) {

  /** The point that has maximum x and y coordinates. */
  val bottomRight: Vector2 = (topRight.x, bottomLeft.y)

  /** The point that has minimum x and y coordinates. */
  val topLeft: Vector2 = (bottomLeft.x, topRight.y)

  /** All points of the bounding box in the order: bottomLeft, bottomRight, topLeft, topRight. */
  def points: List[Vector2] = List(bottomLeft, bottomRight, topLeft, topRight)
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/simulation/collision/AxisAlignedBoundingBox.scala